import type { CSSProperties, ReactNode } from "react";

import { tokens } from "../styles/theme";

export function SectionLabel({ children, style }: { children: ReactNode; style?: CSSProperties }) {
  return (
    <div
      style={{
        fontSize: "11px",
        fontWeight: 600,
        letterSpacing: "0.18em",
        textTransform: "uppercase",
        color: tokens.muted,
        margin: "28px 0 12px",
        ...style,
      }}
    >
      {children}
    </div>
  );
}
